import { render, staticRenderFns } from "./bookingMethod.vue?vue&type=template&id=4264ce78&scoped=true&"
import script from "./bookingMethod.vue?vue&type=script&lang=js&"
export * from "./bookingMethod.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4264ce78",
  null
  
)

export default component.exports